var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOrganiseHomeScreenNavIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_8676",
    "data-name": "Group 8676",
    transform: "translate(-20 -351)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2999",
    "data-name": "Rectangle 2999",
    width: 24,
    height: 24,
    transform: "translate(20 351)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "interface_1_",
    "data-name": "interface (1)",
    transform: "translate(21.472 352.725)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2416",
    "data-name": "Path 2416",
    d: "M20,0H1.052A1.053,1.053,0,0,0,0,1.052V20a1.053,1.053,0,0,0,1.052,1.052H20A1.053,1.053,0,0,0,21.056,20V1.052A1.053,1.053,0,0,0,20,0Zm-.182,1.234V4.677H1.234V1.234ZM1.234,19.821V5.911H19.822v13.91Zm0,0",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2417",
    "data-name": "Path 2417",
    d: "M387.276,59.655h1.182a.542.542,0,1,0,0-1.084h-1.182a.542.542,0,1,0,0,1.084Zm0,0",
    transform: "translate(-370.206 -56.453)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2418",
    "data-name": "Path 2418",
    d: "M320.671,51.7a.82.82,0,1,1-.82-.82A.82.82,0,0,1,320.671,51.7Zm0,0",
    transform: "translate(-305.756 -49.04)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2419",
    "data-name": "Path 2419",
    d: "M257.187,51.7a.82.82,0,1,1-.82-.82A.82.82,0,0,1,257.187,51.7Zm0,0",
    transform: "translate(-244.914 -49.04)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2420",
    "data-name": "Path 2420",
    d: "M241.542,191.9a.542.542,0,0,0-.542.542v1.468a.542.542,0,0,0,1.084,0V192.44A.542.542,0,0,0,241.542,191.9Zm0,0",
    transform: "translate(-231.014 -183.854)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2421",
    "data-name": "Path 2421",
    d: "M167,223.1a.542.542,0,1,0-.767.767l1.038,1.038a.542.542,0,1,0,.767-.767Zm0,0",
    transform: "translate(-159.132 -213.626)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2422",
    "data-name": "Path 2422",
    d: "M137.58,298.413a.542.542,0,0,0-.542-.542h-1.468a.542.542,0,1,0,0,1.084h1.468A.542.542,0,0,0,137.58,298.413Zm0,0",
    transform: "translate(-129.366 -285.529)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2423",
    "data-name": "Path 2423",
    d: "M167.264,344.233l-1.038,1.038a.542.542,0,1,0,.767.767L168.031,345a.542.542,0,0,0-.767-.767Zm0,0",
    transform: "translate(-159.13 -329.703)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2424",
    "data-name": "Path 2424",
    d: "M241.542,363.211a.542.542,0,0,0-.542.542v1.468a.542.542,0,1,0,1.084,0v-1.468A.542.542,0,0,0,241.542,363.211Zm0,0",
    transform: "translate(-231.014 -347.985)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2425",
    "data-name": "Path 2425",
    d: "M288.129,344.233a.542.542,0,0,0-.767.767l1.038,1.038a.542.542,0,1,0,.767-.767Zm0,0",
    transform: "translate(-275.207 -329.703)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2426",
    "data-name": "Path 2426",
    d: "M308.355,297.871h-1.468a.542.542,0,1,0,0,1.084h1.468a.542.542,0,1,0,0-1.084Zm0,0",
    transform: "translate(-293.501 -285.529)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2427",
    "data-name": "Path 2427",
    d: "M287.745,225.059a.54.54,0,0,0,.383-.159l1.038-1.038a.542.542,0,0,0-.767-.767l-1.038,1.038a.542.542,0,0,0,.383.925Zm0,0",
    transform: "translate(-275.206 -213.625)",
    fill: "currentColor"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrganiseHomeScreenNavIcon);
export default __webpack_public_path__ + "static/media/organise-home-screen-nav-icon.60fe1b633b8ec24ef381fefd03b745a5.svg";
export { ForwardRef as ReactComponent };